const CategoryList = {
    importantWeights: {
        human: 0,
    },
    switchWeights: {
        lannister: 1,
        baratheon: 1,
        targaryen: 1,
        martell: 1,
        stark: 1,
        arryn: 1,
        tully: 1,
        greyjoy: 1,
        tyrell: 1,
        other: 1,
    },
    scaleWeights: {
        leader: 5,
        ambitious: 5,
        hedonistic: 5,
    },
    handWeights: {
        pragmatic: 5,
        selfish: 5,
        appearance: 5,
    },
    coinWeights: {
        frugal: 5,
        power: 5,
        steadfast: 5,
    },
    whispersWeights: {
        cynic: 5,
        extrovert: 5,
        authority: 5,
    },
    commanderWeights: {
        brave: 5,
        autocratic: 5,
        deadly: 5,
    },
    grandMaesterWeights: {
        book: 5,
        hands: 5,
        optimistic: 5,
    },
}

export default CategoryList



// WEBPACK FOOTER //
// ./src/utils/CategoryList.js